// Modules
import React, { Component } from 'react';
import { translate } from 'react-translate';
import { withRouter } from 'react-router';
import * as S from './styles';

class StepsCompleted extends Component {
  render() {
    const {
      props: { t },
    } = this;

    return (
      <S.CardWrapper>
        <div>
          <S.TitleWrapper>{t('TITLE')}</S.TitleWrapper>
          <S.TextWrapper>{t('TEXT')}</S.TextWrapper>
        </div>
      </S.CardWrapper>
    );
  }
}

export default withRouter(translate('StepsCompleted')(StepsCompleted));
